export enum Currency {
  EUR = "EUR",
  USD = "USD",
  RUB = "RUB",
  PLN = "PLN",
  GBP = "GBP",
}
